import { adminConstants } from "../_constants"

export default function customer(state = {}, action) {
    switch (action.type) {

        case adminConstants.ADMIN_GET_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case adminConstants.ADMIN_GET_LIST_SUCCESS:
            return {
                ...state,
                adminList: action.admin.data,
                loading: false,
                error: false
            }
        case adminConstants.ADMIN_GET_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }

        case adminConstants.UPDATE_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case adminConstants.UPDATE_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false
            }
        case adminConstants.UPDATE_ADMIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case adminConstants.ADMIN_BLOCK_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case adminConstants.ADMIN_BLOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false
            }
        case adminConstants.ADMIN_BLOCK_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case adminConstants.ADMIN_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case adminConstants.ADMIN_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false
            }
        case adminConstants.ADMIN_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case adminConstants.ADMIN_GET_ASSIGNED_IDS_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case adminConstants.ADMIN_GET_ASSIGNED_IDS_SUCCESS:
            return {
                ...state,
                ids: action.admin.data,
                loading: false,
                error: false
            }
        case adminConstants.ADMIN_GET_ASSIGNED_IDS_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return state
    }
}